import { useGetQuotesListItemsQuery } from "@hooks/policies/useGetQuotesListItems";
import {
  GetQuoteFilterByStatus,
  QuoteListItemsSortBy,
  SortOrder,
} from "@covertree/agent-portal-graphql";
import { useMappedQuotes } from "@hooks/policies/useMappedQuotes";
import { useGetQuotesColumns } from "@hooks/policies/useGetQuotesColumns";

export function useGetRecentQuotes() {
  const {
    quotes: items,
    loading,
    error,
  } = useGetQuotesListItemsQuery({
    pagination: {
      from: 0,
      size: 5,
    },
    sorting: {
      sort: SortOrder.Descending,
      sortBy: QuoteListItemsSortBy.UpdatedTimestamp,
    },
    filter: {
      status: GetQuoteFilterByStatus.Valid,
    },
  });

  const quotes = useMappedQuotes(items, GetQuoteFilterByStatus.Valid);
  const columns = useGetQuotesColumns();

  return {
    loading,
    columns,
    quotes,
    error: !!error,
  };
}
